import { Injectable, inject } from '@angular/core';
import { STORAGE_TOKEN } from '../tokens/storage.token';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage = inject(STORAGE_TOKEN);

  write(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  read(key: string): string | null {
    return this.storage.getItem(key);
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}
